/* UTM & Paid Tracking — v2.1 (Shopify-safe, no regex raras) */
(function(){
  "use strict";

  // Sentinel para verificar ejecución
  try { window.__UTM_ASSET_PING__ = "ok"; console.log("[UTM] asset loaded v2.1"); } catch(e){}

  // Utils
  function once(fn){ var done=false; return function(){ if(!done){ done=true; try{ fn(); }catch(e){} } }; }
  function hasAny(){ for (var i=0;i<arguments.length;i++){ var v=arguments[i]; if (v && String(v).trim()!=="") return true; } return false; }
  function nowISO(){ try { return new Date().toISOString(); } catch(e){ return ""; } }

  // Cookies (sin regex)
  function setCookie(k,v,days){
    try{
      var d=new Date(); d.setTime(d.getTime()+days*86400000);
      document.cookie = k+"="+encodeURIComponent(v)+"; expires="+d.toUTCString()+"; path=/; SameSite=Lax";
    }catch(e){}
  }
  function getCookie(k){
    try{
      var cs = document.cookie ? document.cookie.split("; ") : [];
      for (var i=0;i<cs.length;i++){
        var part = cs[i];
        var eq = part.indexOf("=");
        var name = eq>-1 ? part.substring(0,eq) : part;
        if (name === k) return decodeURIComponent(eq>-1 ? part.substring(eq+1) : "");
      }
      return null;
    }catch(e){ return null; }
  }
  function g(k){ try { return localStorage.getItem(k) || getCookie(k); } catch(e){ return getCookie(k); } }
  function s(k,v){ try{ localStorage.setItem(k,v); }catch(e){} setCookie(k,v,90); }

  // Path + query normalizado
  function normPathQuery(href){
    try{
      var u = new URL(href, location.origin);
      var path = u.pathname.replace(/\/+$/,""); if (path==="") path="/";
      if (/^\/(es|en|ca|ru)$/i.test(path)) path="/";
      var pairs = []; u.searchParams.forEach(function(val,key){ if(val && val.trim().length){ pairs.push([key,val]); }});
      pairs.sort(function(a,b){ return a[0]<b[0]?-1:(a[0]>b[0]?1:0); });
      var q = pairs.length ? ("?"+pairs.map(function(p){ return encodeURIComponent(p[0])+"="+encodeURIComponent(p[1]); }).join("&")) : "";
      return path+q;
    }catch(e){ return ""; }
  }

  function clickIdPresent(qs){
    return qs.has("gclid")||qs.has("fbclid")||qs.has("msclkid")||qs.has("twclid")||qs.has("ttclid");
  }
  function getUTMs(qs){
    return {
      source: qs.get("utm_source")   || "",
      medium: qs.get("utm_medium")   || "",
      campaign:qs.get("utm_campaign")|| "",
      content: qs.get("utm_content") || "",
      term:    qs.get("utm_term")    || ""
    };
  }
  function base64hash(obj){
    try { return btoa(unescape(encodeURIComponent(JSON.stringify(obj)))).slice(0,64); } catch(e){ return ""; }
  }

  function initFromRoot(root){
    try{
      if(!root) return;

      // Settings
      var enabled    = (root.dataset.enabled === "true"); if(!enabled) return;
      var onlyCart   = (root.dataset.runOnlyOnCart === "true");
      var template   = (root.dataset.template || "").toLowerCase();
      var PFX        = "acq_";
      var paidMediums= (root.dataset.paidMediums || "cpc,ppc,paid,paid_social,display,remarketing,retargeting,shopping")
                       .split(",").map(function(s){ return s.trim().toLowerCase(); }).filter(function(x){ return !!x; });
      var detectIds  = (root.dataset.detectClickids === "true");
      var qs         = new URLSearchParams(window.location.search);

      // Reset si vienes de thank_you
      try{
        var ref = document.referrer || "";
        if (/\/checkouts\/.+\/(thank_you|orders)/i.test(ref) || /\/orders\/\d+/i.test(ref)) {
          var keys = ["utm_lt_source","utm_lt_medium","utm_lt_campaign","utm_lt_content","utm_lt_term","utm_lt_ts","utm_lt_paid","utm_payload_hash",
                      "utm_ft_source","utm_ft_medium","utm_ft_campaign","utm_ft_content","utm_ft_term","utm_ft_ts","utm_ft_paid","utm_ft_lp"];
          for (var i=0;i<keys.length;i++){
            try{ localStorage.removeItem(keys[i]); }catch(e){}
            try{ document.cookie = keys[i]+"=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"; }catch(e){}
          }
        }
      }catch(e){}

      // First landing
      if(!g("utm_ft_lp")) s("utm_ft_lp", normPathQuery(location.href));

      // Captura UTMs
      var utm = getUTMs(qs);
      function isPaidTouch(u){
        var m=(u.medium||"").toLowerCase();
        return paidMediums.indexOf(m)>=0 || (detectIds && clickIdPresent(qs));
      }

      if (hasAny(utm.source, utm.medium, utm.campaign, utm.content, utm.term)) {
        var paid = isPaidTouch(utm) ? "yes" : "no";
        if (!g("utm_ft_source")) {
          s("utm_ft_source", utm.source);
          s("utm_ft_medium", utm.medium);
          s("utm_ft_campaign", utm.campaign);
          s("utm_ft_content", utm.content);
          s("utm_ft_term", utm.term);
          s("utm_ft_ts", nowISO());
          s("utm_ft_paid", paid);
        }
        s("utm_lt_source", utm.source);
        s("utm_lt_medium", utm.medium);
        s("utm_lt_campaign", utm.campaign);
        s("utm_lt_content", utm.content);
        s("utm_lt_term", utm.term);
        s("utm_lt_ts", nowISO());
        s("utm_lt_paid", paid);
      } else if (detectIds && clickIdPresent(qs)) {
        if (!g("utm_lt_paid") || g("utm_lt_paid")==="no") s("utm_lt_paid","yes");
        if (!g("utm_lt_ts")) s("utm_lt_ts", nowISO());
        if (!g("utm_lt_medium")) s("utm_lt_medium","cpc");
      }

      // Payload
      function buildPayload(){
        var lt = {
          source: g("utm_lt_source")||"",
          medium: g("utm_lt_medium")||"",
          campaign:g("utm_lt_campaign")||"",
          content:g("utm_lt_content")||"",
          term:   g("utm_lt_term")||"",
          ts:     g("utm_lt_ts")||"",
          paid:   g("utm_lt_paid")||""
        };
        var ft = {
          source: g("utm_ft_source")||"",
          medium: g("utm_ft_medium")||"",
          campaign:g("utm_ft_campaign")||"",
          content:g("utm_ft_content")||"",
          term:   g("utm_ft_term")||"",
          ts:     g("utm_ft_ts")||"",
          paid:   g("utm_ft_paid")||"",
          lp:     g("utm_ft_lp")||""
        };
        var exists = hasAny(lt.source, lt.medium, lt.campaign, lt.paid) || hasAny(ft.source, ft.medium, ft.campaign, ft.lp);
        if(!exists) return null;

        var attrs = {};
        var ltPaid = (lt.paid==="yes") || (paidMediums.indexOf((lt.medium||"").toLowerCase())>=0) ? "yes" : "no";

        attrs[PFX+"paid"]        = ltPaid;
        attrs[PFX+"source"]      = lt.source;
        attrs[PFX+"medium"]      = lt.medium;
        attrs[PFX+"campaign"]    = lt.campaign;
        attrs[PFX+"content"]     = lt.content;
        attrs[PFX+"term"]        = lt.term;
        attrs[PFX+"touch_ts"]    = lt.ts;

        attrs[PFX+"first_paid"]     = (ft.paid==="yes")?"yes":"no";
        attrs[PFX+"first_source"]   = ft.source;
        attrs[PFX+"first_medium"]   = ft.medium;
        attrs[PFX+"first_campaign"] = ft.campaign;
        attrs[PFX+"first_content"]  = ft.content;
        attrs[PFX+"first_term"]     = ft.term;
        attrs[PFX+"first_ts"]       = ft.ts;
        if (ft.lp) attrs[PFX+"first_lp"] = ft.lp;

        return { attributes: attrs };
      }

      function writeToCart(payload){
        try{
          if(!payload) return;
          var newHash = base64hash(payload);
          var lastHash = g("utm_payload_hash");
          if (newHash && newHash === lastHash) return;

          fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "same-origin",
            body: JSON.stringify(payload)
          })
          .then(function(r){ if(!r.ok) throw new Error("bad response"); })
          .then(function(){ s("utm_payload_hash", newHash || ""); console.log("[UTM] cart updated"); })
          .catch(function(){});
        }catch(e){}
      }

      var pushOnce = once(function(){ writeToCart(buildPayload()); });

      // Disparo
      if (onlyCart) {
        if (template === "cart") {
          pushOnce();
        } else {
          try{
            var ofetch = window.fetch;
            window.fetch = function(input, init){
              var url = (typeof input === "string" ? input : (input && input.url) || "") || "";
              var method = (init && (init.method||"GET")) || (input && input.method) || "GET";
              var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url) && method.toUpperCase()==="POST";
              return ofetch.apply(this, arguments).then(function(res){
                try{ if(isAdd){ res.clone().text().then(function(){ pushOnce(); }); } }catch(e){}
                return res;
              });
            };
          }catch(e){}
          try{
            var xopen = XMLHttpRequest.prototype.open;
            XMLHttpRequest.prototype.open = function(method, url){
              this.__isAdd = /\/cart\/add(\.js)?(\?|$)/.test(String(url)) && (method||"GET").toUpperCase()==="POST";
              return xopen.apply(this, arguments);
            };
            var xsend = XMLHttpRequest.prototype.send;
            XMLHttpRequest.prototype.send = function(){
              if (this.__isAdd) this.addEventListener("loadend", function(){ pushOnce(); }, { once:true });
              return xsend.apply(this, arguments);
            };
          }catch(e){}
        }
      } else {
        if (template === "cart") {
          pushOnce();
        } else {
          fetch("/cart.js", { credentials:"same-origin" })
            .then(function(r){ return r.ok ? r.json() : Promise.reject(); })
            .then(function(c){ if (c && c.item_count > 0) pushOnce(); })
            .catch(function(){});
          try{
            var ofetch2 = window.fetch;
            window.fetch = function(input, init){
              var url = (typeof input === "string" ? input : (input && input.url) || "") || "";
              var method = (init && (init.method||"GET")) || (input && input.method) || "GET";
              var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url) && method.toUpperCase()==="POST";
              return ofetch2.apply(this, arguments).then(function(res){
                try{ if(isAdd){ res.clone().text().then(function(){ pushOnce(); }); } }catch(e){}
                return res;
              });
            };
          }catch(e){}
          try{
            var xopen2 = XMLHttpRequest.prototype.open;
            XMLHttpRequest.prototype.open = function(method, url){
              this.__isAdd = /\/cart\/add(\.js)?(\?|$)/.test(String(url)) && (method||"GET").toUpperCase()==="POST";
              return xopen2.apply(this, arguments);
            };
            var xsend2 = XMLHttpRequest.prototype.send;
            XMLHttpRequest.prototype.send = function(){
              if (this.__isAdd) this.addEventListener("loadend", function(){ pushOnce(); }, { once:true });
              return xsend2.apply(this, arguments);
            };
          }catch(e){}
        }
      }
    } catch(e){ console.warn("[UTM] init error", e); }
  }

  // Global + autoinit
  try { window.UtmPaidTracking = { initFromRoot: initFromRoot, version: "2.1.0" }; } catch(e){}
  function autoInit(){ try{ var root=document.getElementById("utm-paid-tracking"); if(root) initFromRoot(root); }catch(e){} }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", autoInit, { once:true });
  else autoInit();
})();
